<div id="layout" class="sign_in f_col">
  <app-view-title fromRoute="document-management" [chooseLangBtn]="false">{{'documentContinue.title' | translate}}</app-view-title>
  <div class="scroll_wrapper resp_wrapper">
    <div class="resp_scroll-wrapper_l resp_c-50">
      <app-view-deco-image class="mt_20 mb_20" imageUrl="assets-projects/images/image_cart.svg"></app-view-deco-image>

      <span class="text_center mb_20">{{'documentContinue.desc1' | translate}}</span>
      <span class="text_center mb_20">{{'documentContinue.desc2' | translate}}</span>
      <div>
        <app-slide-element leftIcon="shopping-cart" (btnClicked)="nav.to(cart.cartDatas.state === 'meansPayment' ? 'means-payment' :  cart.cartDatas.state === 'onlinePayment' ? 'online-payment' : 'process-payment')" class="mb_10">
          {{'documentContinue.title' | translate}}
        </app-slide-element>
        <app-slide-element leftIcon="rotate-right" (btnClicked)="clickStop()" class="mb_10">
          {{'documentContinue.stop' | translate}}
        </app-slide-element>
      </div>

      <div class="resp_minSize_l mb_20 mt_20 flex gap_10">
        <app-button size="xsm" color="transparent" border="true" class="fullWidth" (btnClicked)="nav.to('dashboard')">
          {{'global.back' | translate}}
        </app-button>
      </div>
    </div>
  </div>

  <div class="f_align_end mb_20 resp_maxSize_l">
    <app-back-btn class="mr_10" icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
  </div>
</div>
